import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07dd9d28"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-photos-header"
}
const _hoisted_2 = { class: "d-photos-header-nav" }
const _hoisted_3 = {
  key: 0,
  class: "icon icon-back"
}
const _hoisted_4 = { class: "d-photos-header__title" }
const _hoisted_5 = { class: "d-layout-switcher" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Drop some files here ")
const _hoisted_7 = { class: "title-search" }
const _hoisted_8 = {
  key: 0,
  class: "drop-zone"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drop-zone__body" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "drop-zone__icon icon icon-download" }),
  /*#__PURE__*/_createElementVNode("span", { class: "drop-zone__text" }, "Drop some files here")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "title-search" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drive_load_bar = _resolveComponent("drive-load-bar")!
  const _component_app_drop_zone = _resolveComponent("app-drop-zone")!
  const _component_item_mixed = _resolveComponent("item-mixed")!
  const _component_app_skeleton_folder = _resolveComponent("app-skeleton-folder")!
  const _component_refresh_pull = _resolveComponent("refresh-pull")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.mainStore.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.mainStore.uploadInfos.length && !_ctx.mainStore.isMobile)
            ? (_openBlock(), _createBlock(_component_drive_load_bar, {
                key: 0,
                class: "loadbar",
                uploadInfo: _ctx.mainStore.getUploadInfo
              }, null, 8, ["uploadInfo"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("a", {
              href: "javascript:void(0);",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.backAction && _ctx.backAction(...args)), ["prevent"])),
              class: "back-link"
            }, [
              (_ctx.backArrow)
                ? (_openBlock(), _createElementBlock("i", _hoisted_3))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.driveStore.currentFolder?.name), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(["d-layout-switcher__btn icon", !_ctx.driveStore.isGridFolderView ? 'active icon-list-view-2-active' : 'icon-list-view-2']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.driveStore.isGridFolderView = false))
            }, null, 2),
            _createElementVNode("span", {
              class: _normalizeClass(["d-layout-switcher__btn icon", _ctx.driveStore.isGridFolderView ? 'active icon-tiles-2-active' : 'icon-tiles-2']),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.driveStore.isGridFolderView = true))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.mainStore.isMobile)
      ? (_openBlock(), _createBlock(_component_refresh_pull, {
          key: 1,
          modelValue: _ctx.loadingPull,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.loadingPull) = $event)),
          onRefresh: _ctx.onRefresh,
          successText: _ctx.successText,
          pullingText: _ctx.pullingText,
          loosingText: _ctx.loosingText,
          loadingText: _ctx.loadingText
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              ref: "scroller",
              class: "scroll",
              onScroll: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
            }, [
              (_ctx.isOverDropZone)
                ? (_openBlock(), _createBlock(_component_app_drop_zone, {
                    key: 0,
                    "indents-height": 141,
                    class: "drop-zone-box"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_item_mixed, {
                mixedList: _ctx.driveStore.currentFolder?.mixedData || [],
                column: !_ctx.driveStore.isGridFolderView,
                selector: _ctx.driveStore.isMixedSelector,
                loading: _ctx.isPageLoading
              }, null, 8, ["mixedList", "column", "selector", "loading"]),
              (_ctx.loader)
                ? (_openBlock(), _createBlock(_component_app_skeleton_folder, {
                    key: 1,
                    title: _ctx.driveStore.currentFolder?.name,
                    grid: _ctx.driveStore.isGridFolderView,
                    hideSkeletons: _ctx.hideSkeletons
                  }, null, 8, ["title", "grid", "hideSkeletons"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.responseMessage), 1)
            ], 544)
          ]),
          _: 1
        }, 8, ["modelValue", "onRefresh", "successText", "pullingText", "loosingText", "loadingText"]))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          ref: "scroller",
          class: "scroll",
          onScroll: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
        }, [
          (_ctx.isOverDropZone)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
            : _createCommentVNode("", true),
          _createVNode(_component_item_mixed, {
            mixedList: _ctx.driveStore.currentFolder?.mixedData || [],
            column: !_ctx.driveStore.isGridFolderView,
            selector: _ctx.driveStore.isMixedSelector,
            loading: _ctx.isPageLoading
          }, null, 8, ["mixedList", "column", "selector", "loading"]),
          (_ctx.loader)
            ? (_openBlock(), _createBlock(_component_app_skeleton_folder, {
                key: 1,
                title: _ctx.driveStore.currentFolder?.name,
                grid: _ctx.driveStore.isGridFolderView,
                hideSkeletons: _ctx.hideSkeletons
              }, null, 8, ["title", "grid", "hideSkeletons"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.responseMessage), 1)
        ], 544))
  ]))
}